import { css } from "theme/default/css";

export const setFlexDFFDC = css`
  display: flex;
  flex-direction: column;
`;
